import React, { useContext, useEffect, useState } from 'react';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';
import { Row, Button, Widget, FormSubmitButton, MasterDetailView, SimpleView, MasterDetailForm } from '@digital/ui';
import { Modal } from 'antd';

function ModalConcordarEnviarPreSuprimentos() {
  const { exibirModalEnviarPreSuprimentos, setExibirModalEnviarPreSuprimentos } = useContext(
    QuestionarioContextProvider,
  );

  let variavel: string = '';
  const onDiscordar = () => {
    setExibirModalEnviarPreSuprimentos(false);
  };

  return (
    <Modal
      title="Expectativa de Conclusão"
      width="680px"
      visible={exibirModalEnviarPreSuprimentos}
      onCancel={() => {
        setExibirModalEnviarPreSuprimentos(false);
      }}
      className="chat-modal"
      footer={[
        <Button key="discordarBtn" type="link" onClick={() => onDiscordar()}>
          Não
        </Button>,
        <FormSubmitButton noIcon key="concordarBtn" type="primary">
          Sim
        </FormSubmitButton>,
      ]}>
      <MasterDetailForm>
        <Widget>
          <Row>
            <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
              Com essa alteração de valor a demanda terá que ser submetida a validação da área de Pré-Suprimentos.
              Confirma a alteração?
            </p>
          </Row>
        </Widget>
      </MasterDetailForm>
    </Modal>
  );
}

export default ModalConcordarEnviarPreSuprimentos;
